import { render } from "./KoruImageUpload.vue?vue&type=template&id=4c7c0300&ts=true"
import script from "./KoruImageUpload.vue?vue&type=script&lang=ts"
export * from "./KoruImageUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__